import TabManager from "./TabManager";
import OutputSelectionManager from "./OutputSelectionManager";
import Analytics from "../util/Analytics";
import {CONFIG_THUMBNAIL_MAX_INPUT_SIZE} from "../config/thumbnails.config";
import {CONFIG_PREVIEW_FILES, CONFIG_PREVIEW_MINI} from "../config/preview.config";
import {CONFIG_FEATURES} from "../config/features.config";

class PreviewManager {

    features = CONFIG_FEATURES;
    previews = CONFIG_PREVIEW_FILES;
    previews_mini = CONFIG_PREVIEW_MINI;

    listener = false;

    constructor() {
    }

    updatePath(path, jobId, outputId = 'no_output_id') {
        path = path.replace('no_job_id', jobId);
        path = path.replace('no_output_id', outputId);
        return path;
    }

    getPreviewItemByExtenion(extension) {
        return this.previews.filter((item) => item.extension === extension)
    }

    getPreviewMiniItemByExtenion(extension) {
        return this.previews_mini.filter((item) => item.extension === extension)
    }

    getFeatureItemByJob(job) {
        let feature = this.features.filter((item) => (item.category === job.apiJob.conversion[0].category && item.target === job.apiJob.conversion[0].target))

        if (feature.length > 0) {
            return feature;
        }

        feature = this.features.filter((item) => (item.operation === job.apiJob.sat.operation))

        if (feature.length > 0) {
            return feature;
        }

        feature = this.features.filter((item) => (item.category === job.apiJob.conversion[0].category && item.target === null))

        if (feature.length > 0) {
            return feature;
        }

        return [];
    }

    canPreview(extension) {
        return this.getPreviewItemByExtenion(extension).length > 0;
    }

    canPreviewMini(extension, size) {
        return this.getPreviewMiniItemByExtenion(extension).length > 0 && size < CONFIG_THUMBNAIL_MAX_INPUT_SIZE;
    }

    hasFeature(job) {
        if (this.getFeatureItemByJob(job).length > 0) {
            return true;
        }

        return false;
    }

    canPreviewSelectedOne(job) {
        let selectedOutputs = OutputSelectionManager.getSelectedOutputs(job);
        if (selectedOutputs.length === 1) {
            return this.canPreview(this.getExtensionFromOutput(selectedOutputs[0]));
        }

        return false;
    }

    openPreview(job, output) {
        if (this.canPreview(this.getExtensionFromOutput(output)) === false) {
            return;
        }

        let preview = this.getPreviewItemByExtenion(this.getExtensionFromOutput(output));
        let tab = TabManager.create();

        tab.name = this.getFilenameFromOutput(output);
        tab.path = this.updatePath(preview[0].path, job.id, output.id);
        tab.type = preview[0].type;

        TabManager.createTab(tab);
        TabManager.openTab(tab);
    }

    openInitialFeature(job) {
        let preview = this.getFeatureItemByJob(job);
        Analytics.send('result_action', `open_initial_feature_${preview[0].type}`, job);

        let tab = TabManager.create();
        tab.name = 'Processing';
        tab.path = this.updatePath(preview[0].path, job.id);
        tab.type = preview[0].type;
        tab.dismissable = preview[0].dismissable;

        TabManager.createTab(tab);
        TabManager.openTab(tab);
    }

    openInitialPreview(job) {
        let preview = this.getPreviewItemByExtenion(job.apiJob.conversion[0].target);
        Analytics.send('result_action', `open_initial_preview_${preview[0].type}`, job);

        let tab = TabManager.create();
        tab.name = 'Processing';
        tab.path = this.updatePath(preview[0].path, job.id);
        tab.type = preview[0].type;

        TabManager.createTab(tab);
        TabManager.openTab(tab);
    }

    getFilenameFromOutput(output) {
        let lastSlashIndex = output.uri.lastIndexOf('/')
        return output.uri.substring(lastSlashIndex + 1)
    }

    getExtensionFromOutput(output) {
        let lastSlashIndex = output.uri.lastIndexOf('.')
        return output.uri.substring(lastSlashIndex + 1)
    }
}

export default new PreviewManager()